import React from "react";
import { decamelize } from "humps";
import TextField from "../form-fields/TextField";
import SelectField from "../form-fields/SelectField";
import { countyOptions } from "../../data/countries";
import { OptionProps } from "../controls/Select";

interface Props {
  cityFieldI18nKey?: string;
  countryOptions: OptionProps[];
  countryCodeFieldName?: string;
  isUpperCaseName?: boolean;
  prefix?: string;
}

const AddressFields = (props: Props): JSX.Element => {
  const { countryCodeFieldName = "addressCountryCode", countryOptions, prefix = "" } = props;

  const getFieldName = (name: string) => props.isUpperCaseName ? `${name[0].toUpperCase()}${name.slice(1)}` : name;

  return (
    <>
      <div className="DoubleFieldGroup">
        <SelectField
          className="Form-field"
          i18nKey="attributes.country_id"
          id={`field_${decamelize(countryCodeFieldName)}`}
          name={prefix + countryCodeFieldName}
          options={countryOptions}
        />
        <TextField
          className="Form-field"
          i18key={props.cityFieldI18nKey || "attributes.city"}
          id="field_city"
          name={`${prefix}${getFieldName("city")}`}
        />
      </div>
      <TextField
        className="Form-field"
        i18key="attributes.street"
        id="field_street"
        name={`${prefix}${getFieldName("street")}`}
      />
      <div className="DoubleFieldGroup">
        <TextField
          className="Form-field"
          i18key="attributes.house_number"
          id="field_house_number"
          name={`${prefix}${getFieldName("houseNumber")}`}
        />
        <TextField
          className="Form-field"
          i18key="attributes.apartment_number"
          id="field_apartment_number"
          name={`${prefix}${getFieldName("apartmentNumber")}`}
        />
      </div>
      <div className="DoubleFieldGroup">
        <TextField
          className="Form-field"
          i18key="attributes.postal_code"
          id="field_postal_code"
          name={`${prefix}${getFieldName("postalCode")}`}
        />
        <SelectField
          className="Form-field"
          i18nKey="attributes.county"
          id="field_county"
          name={`${prefix}${getFieldName("county")}`}
          options={countyOptions}
        />
      </div>
    </>
  )
}

export default AddressFields;
